"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPermissionStore = void 0;
const trackable_set_1 = require("./trackable-set");
const defaultPermissionChangeHandler = () => {
    /** Default permission change handler */
};
function createPermissionStore(options = {}) {
    const availablePermissions = new trackable_set_1.TrackableSet();
    const { onChange = defaultPermissionChangeHandler } = options;
    availablePermissions.on('change', onChange);
    return {
        has(key) {
            return availablePermissions.has(key);
        },
        add(...permissions) {
            permissions.forEach(p => availablePermissions.add(p));
        },
        remove(...permissions) {
            permissions.forEach(p => availablePermissions.delete(p));
        },
        clear() {
            availablePermissions.clear();
        },
        subscribe(listener) {
            availablePermissions.on('change', listener);
            return {
                dispose() {
                    availablePermissions.off('change', listener);
                }
            };
        }
    };
}
exports.createPermissionStore = createPermissionStore;
//# sourceMappingURL=permission-store.js.map